import React, { Component } from 'react'
import { connect } from 'react-redux'

import moment from 'moment'

import { requestAppBuilds } from 'utils/io'
import { getApp } from 'ducks/apps'

import {
  getAppBuildsState,
  ensureAppBuildsAreLoaded,
  startAppBuild,
} from 'ducks/apps/builds'

import Button from 'components/Shared/Button'

import MobilePublishSummary from '../MobilePublishSummary'
import IOSSettingsModal from './SettingsModal'
import BuildList from '../BuildList/BuildList'
import NewVersionModal from '../NewVersionModal'
import VerifyCredentialsModal from './VerifyCredentialsModal'

class IOSPublish extends Component {
  state = { currentModal: null }

  handleStartBuild = async ({ version }) => {
    const { appId, startAppBuild } = this.props
    startAppBuild(appId, 'ios', version)
  }

  handleNewBuild = () => {
    this.setState({ currentModal: ['settings', 'credentials', 'version'] })
  }

  handleOpenSettings = () => {
    this.setState({ currentModal: ['settings'] })
  }

  handleCloseModal = () => {
    this.setState({ currentModal: null })
  }

  handleSaveSettings = () => {
    let { currentModal } = this.state

    if (currentModal?.length > 1) {
      currentModal = currentModal.slice(1)
    } else {
      currentModal = null
    }

    this.setState({ currentModal })
  }

  handleContinue = () => {
    let { currentModal } = this.state

    if (!currentModal || !currentModal.length > 1) {
      currentModal = null
    } else {
      currentModal = currentModal.slice(1)
    }

    this.setState({ currentModal })
  }

  handleCredentialValidation = () => {
    const { iosSettings } = this.props

    if (!iosSettings) return false

    const { bundleId, appSpecificPassword, applePassword, appleUsername } =
      iosSettings

    if (!bundleId || !appSpecificPassword || !applePassword || !appleUsername) {
      return false
    }

    return true
  }

  handleAppSettingsValidation = () => {
    const { iosSettings } = this.props
    const { displayName, launchScreenColor, launchScreenIcon } = iosSettings

    if (!displayName || !launchScreenColor || !launchScreenIcon) return false

    return true
  }

  requestData = () => {
    const { appId } = this.props

    requestAppBuilds(appId, 'ios', { order: 'DESC' })
  }

  componentDidMount() {
    const { appId, ensureAppBuildsAreLoaded } = this.props

    ensureAppBuildsAreLoaded(appId, 'ios')

    this.timer = window.setInterval(this.requestData, 5000)
  }

  componentWillUnmount() {
    window.clearTimeout(this.timer)
  }

  render() {
    const {
      appId,
      iosSettings,
      lastVersion,
      buildList,
      disableButton,
      loadingBuilds,
    } = this.props

    const { currentModal } = this.state

    const currentModalName = currentModal && currentModal[0]

    const initialValues = { launchScreenColor: '#ffffff', ...iosSettings }

    return (
      <div>
        <div className="mobile-publish-settings">
          <h2>iOS Export Settings</h2>
          <MobilePublishSummary
            provider="ios"
            onUpdateSettings={this.handleOpenSettings}
            handleCredentialValidation={this.handleCredentialValidation}
            handleAppSettingsValidation={this.handleAppSettingsValidation}
          />
          <h2>TestFlight Builds</h2>
          <Button
            fluid
            outlined
            green
            icon={disableButton ? '' : 'plus-small'}
            onClick={this.handleNewBuild}
            disabled={disableButton}
          >
            {disableButton
              ? 'Build In Progress...'
              : 'Start New TestFlight Build'}
          </Button>
          <BuildList appId={appId} list={buildList} loading={loadingBuilds} />
          {currentModalName === 'settings' ? (
            <IOSSettingsModal
              appId={appId}
              onClose={this.handleCloseModal}
              onSubmit={this.handleSaveSettings}
              publishing={currentModal?.length > 1}
              initialValues={initialValues}
              iosSettings={iosSettings}
            />
          ) : currentModalName === 'credentials' ? (
            <VerifyCredentialsModal
              appId={appId}
              onClose={this.handleCloseModal}
              onBack={this.handleNewBuild}
              onContinue={this.handleContinue}
            />
          ) : currentModalName === 'version' ? (
            <NewVersionModal
              target="ios"
              lastVersion={lastVersion}
              onClose={this.handleCloseModal}
              onSubmit={this.handleStartBuild}
            />
          ) : null}
        </div>
      </div>
    )
  }
}

function mapStateToProps(state, { appId }) {
  const app = getApp(state, appId)
  const iosSettings = (app && app.iosSettings) || {}
  const buildsState = getAppBuildsState(state, appId, 'ios')

  const buildList = buildsState && buildsState.list

  const disableButton =
    buildList &&
    buildList.find(
      build =>
        (build.status === 'queued' || build.status === 'building') &&
        moment(build.createdAt).diff(Date.now(), 'hours') > -2
    )

  return {
    iosSettings,
    loadingBuilds: buildsState ? buildsState.loading : true,
    buildList,
    lastVersion: buildsState && buildsState.lastVersion,
    disableButton,
  }
}

export default connect(mapStateToProps, {
  ensureAppBuildsAreLoaded,
  startAppBuild,
})(IOSPublish)
